export function Villaprice(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}>
          <path
            fill="currentColor"
            d="M12 2c-4.42 0-8 3.58-8 8c0 4.42 3.58 8 8 8s8-3.58 8-8c0-4.42-3.58-8-8-8m0 14c-2.21 0-4-1.79-4-4s1.79-4 4-4s4 1.79 4 4s-1.79 4-4 4m0-7h-2v2h-2v-2H8v-2h2V7h2v2h2v2Z"
          ></path>
        </svg>
      );
  }